module.exports = __webpack_public_path__ + "static/template-home-hero-background-a2554b084f2ff20fcb60069ecb8055f8.jpg";